import React, { useState, useEffect } from "react";
import { partyColors } from './ApiUtils';
import { parseBarChartData } from "./Utils";

const barHeight = 100;
const bgColor = '#f5f6ff';

export default function BarChart(props) {

    let { mapWidth, mpMla1Count, mpMla2Count, allPartyList, currentState, stateResults,
        group1List, group2List, partyLogos } = props;
    let chartWidth = mapWidth+60;
    let barWidth = chartWidth/2-100;
    let isIndia = currentState=='IN';
    if(isIndia) { barWidth*=2; }

    const [partyInfo, setPartyInfo] = useState([]);
    const [maxLeadValue, setMaxLeadValue] = useState(0);
    const [isMLA, setIsMLA] = useState(true);

    useEffect(() => {
        console.log('Chart use effect triggered.');
        if(stateResults) {
            if(isIndia) {
                if(allPartyList) {
                    let { barChartData, maxValue }
                        = parseBarChartData(allPartyList, group1List, group2List, mpMla1Count, mpMla2Count, partyLogos);
                    setPartyInfo(barChartData);
                    setMaxLeadValue(maxValue);
                }
            } else {
                let currentStateData = stateResults[currentState];
                if(currentStateData) {
                    setIsMLA(stateResults[currentState].mla);
                    console.log('currentStateData=',currentStateData);
                    let { barChartData, maxValue }
                        = parseBarChartData(allPartyList, group1List, group2List, mpMla1Count, mpMla2Count, partyLogos);
                    setPartyInfo(barChartData);
                    setMaxLeadValue(maxValue);
                }
            }
        }
    }, [props]);

    const partyUIMLA = (item, leads, leadText, isMLA) => {
        return (
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'row', width: barWidth,
            height: barHeight }}>
                <div style={{ flex: 1, display: isMLA ? 'flex' : 'none' }} />
                <div style={{ display: 'flex', width: (barWidth*leads)/maxLeadValue, 
                backgroundColor: partyColors[item.party] }} />
                <div style={{ flex: 1, display: isMLA ? 'none' : 'flex' }} />
                <div style={{ position: 'absolute', display: 'flex', width: barWidth, height: barHeight,
                alignItems: 'center', fontSize: 25, color: '#1a2a3a', fontWeight: 'bold', paddingLeft: 15 }}>
                    {leads}
                    <div style={{ fontSize: 16, paddingLeft: 8 }} >{leadText}</div>
                </div>
            </div>
        );
    }

    const partyUIMP = (item, leads, leadText, isMLA) => {
        return (
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'row', width: barWidth,
            height: barHeight }}>
                <div style={{ flex: 1, display: isMLA ? 'flex' : 'none' }} />
                <div style={{ display: 'flex', width: (barWidth*leads)/maxLeadValue, 
                backgroundColor: partyColors[item.party] }} />
                <div style={{ flex: 1, display: isMLA ? 'none' : 'flex' }} />
                <div style={{ position: 'absolute', display: 'flex', width: barWidth, height: barHeight,
                justifyContent: 'right', alignItems: 'center', fontSize: 25, color: '#1a2a3a',
                fontWeight: 'bold', right: 15 }}>
                    <div style={{ fontSize: 16, paddingRight: 8 }} >{leadText}</div>{leads}
                </div>
            </div>
        );
    }

    const partyNameLogo = (item) => {
        let imageLogo = <img src={item.logo} width={50} />;
        let partyName = item.party;
        if(item.party=='GROUP1') {
            imageLogo = <img src={require('./assets/groupA.png')} width={32} />;
            partyName = 'GROUP A';
        }
        if(item.party=='GROUP2') {
            imageLogo = <img src={require('./assets/groupB.png')} width={32} />;
            partyName = 'GROUP B';
        }
        return (
            <div style={{ display: 'flex', width: 100, height: barHeight-1, justifyContent: 'center',
            alignItems: 'center', flexDirection: 'column', border: '1px solid #c3c7c9',
            borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0, borderStyle: 'dashed' }}>
                {imageLogo}
                <div style={{ fontWeight: 'bold', color: '#3a4a5a' }}>
                {partyName}
                </div>
            </div>
        );
    }

    console.log('partyInfo=',partyInfo);

    if(isIndia||(!isMLA)) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', margin: '30px 30px 50px 20px',
            border: '2px solid #D5D6DD' }}>
                <div style={{ display: 'flex', flexDirection: 'row', width: chartWidth-100, height: 60,
                alignItems: 'center', fontWeight: 'bold', backgroundColor: '#fffafa', border: '0px solid #D5D6DD',
                borderBottomWidth: 2, color: '#3a4a5a', fontSize: 20 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: 100, alignItems: 'center' }}>
                        Parties
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', width: barWidth, alignItems: 'center' }}>
                        MP
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', width: chartWidth-100, justifyContent: 'center',
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: 100,
                    backgroundColor: '#fff' }}>
                        {partyInfo.map((item) => partyNameLogo(item))}
                    </div>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'column', backgroundColor: bgColor }}>
                        {partyInfo.map((item) => partyUIMLA(item, item.mpLeads, item.mpText, false))}
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', margin: '30px 30px 50px 20px',
        border: '2px solid #D5D6DD' }}>
            <div style={{ display: 'flex', flexDirection: 'row', width: chartWidth-100, height: 60,
            alignItems: 'center', fontWeight: 'bold', backgroundColor: '#fffafa', border: '0px solid #D5D6DD',
            borderBottomWidth: 2, color: '#3a4a5a', fontSize: 20 }}>
                <div style={{ display: 'flex', flexDirection: 'column', width: barWidth, alignItems: 'center' }}>
                    MP
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: 100, alignItems: 'center' }}>
                    Parties
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: barWidth, alignItems: 'center' }}>
                    MLA
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', width: chartWidth-100, justifyContent: 'center',
             }}>
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: bgColor }}>
                    {partyInfo.map((item) => partyUIMP(item, item.mpLeads, item.mpText, true))}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', width: 100, backgroundColor: '#fff' }}>
                    {partyInfo.map((item) => partyNameLogo(item))}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: bgColor }}>
                    {partyInfo.map((item) => partyUIMLA(item, item.mlaLeads, item.mlaText, false))}
                </div>
            </div>
        </div>
    );
};